'use client'

import type { ReactNode } from 'react'

import { CompactTable } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

const COLUMNS = 8

interface DashboardPositionsCardSkeletonProps {
  testId?: string
  filters: ReactNode
  rows: number
  mobileRows: ReactNode
}

// Mirrors the loaded positions card: on lg: a bordered card with the filters
// header, a table header and `rows` 63px rows; below lg: the filters row and
// one card per row. Both breakpoints SSR; see the useIsMobile JSDoc.
const DashboardPositionsCardSkeleton = ({
  testId,
  filters,
  rows,
  mobileRows
}: DashboardPositionsCardSkeletonProps) => {
  return (
    <div
      data-testid={testId}
      className="gap-sm lg:border-border lg:bg-card flex flex-col lg:gap-0 lg:rounded-[20px] lg:border-[0.5px] lg:shadow-md lg:dark:shadow-none"
    >
      <div className="lg:p-md">{filters}</div>
      <div className="border-border overflow-hidden rounded-b-[20px] border-t-[0.5px] max-lg:hidden">
        <CompactTable className="w-full table-fixed">
          <CompactTable.Head>
            <CompactTable.HeadRow>
              {Array.from({ length: COLUMNS }).map((_, index) => (
                <CompactTable.HeaderCell key={index}>
                  <Skeleton className="h-sm w-[64px] rounded-full" />
                </CompactTable.HeaderCell>
              ))}
            </CompactTable.HeadRow>
          </CompactTable.Head>
          <CompactTable.Body>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <CompactTable.SkeletonRow
                key={rowIndex}
                keyPrefix={`row-${rowIndex}`}
                cells={Array.from({ length: COLUMNS }).map((_, cellIndex) => (
                  <Skeleton key={cellIndex} className="h-md w-full rounded-full" />
                ))}
              />
            ))}
          </CompactTable.Body>
        </CompactTable>
      </div>
      <div className="lg:hidden">{mobileRows}</div>
    </div>
  )
}

export default DashboardPositionsCardSkeleton
